import { GetOrganizationDomainsWithCountersQuery } from "../types/queries.generated";
import { GET_ORGANIZATION_DOMAINS_WITH_COUNTERS } from "../queries";
import { useModelsQuery } from "apps/platform-client/client/src/hooks/useModelsModule";

export const useOrganizationDomains = () =>
	useModelsQuery<GetOrganizationDomainsWithCountersQuery>(GET_ORGANIZATION_DOMAINS_WITH_COUNTERS, {
		fetchPolicy: "no-cache",
	});
